<template>
  <div class="topBanner wow animate__animated animate__fadeIn">
    <div class="bannerBox">
      <div class="topLeft">
        <div class="bannerTitle">
          <div class="topLeftTitle">万物互联，智能驱动未来</div>
          <div class="topleftSubTitle">
            全球领先的实验室智能化解决方案引领者
          </div>
        </div>
        <div class="commonBtn">
          <CommonBtn class="maria" title="行业解决方案" @click="clickSolution" style="max-width: 7rem">
          </CommonBtn>
        </div>
      </div>
      <div class="topImg">
        <OssImg 
          src="images/home3.png"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import CommonBtn from "@/components/commenBtn.vue";
onMounted(() => {
  //10s后清除banner动画
  const title = document.querySelector(".topLeftTitle");
  // 10s 后移除 border-right
  setTimeout(() => {
    title.style.border = "none";
  }, 6000);
});

const emits = defineEmits('clickSolution')

const clickSolution = () => {
  emits('clickSolution')
}
</script>

<style lang="scss" scoped>
.topBanner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2.75rem;
  padding-bottom: 5rem;
  box-sizing: border-box;

  .bannerBox {
    width: 100%;
    display: flex;
    font-size: 1vw;
  }

  .topLeft {
    width: 35%;
    z-index: 99;
    white-space: nowrap;
    padding: 3.5em 0 3.5em 3.5em;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: -3rem;

    .commonBtn{
      margin-top: 10em;
      display: flex;
    }

    .topLeftTitle {
      width: auto;
      padding-right: 5px;
      display: inline-block;
      box-sizing: border-box;
      position: relative;
      z-index: 999;
      color: #212121;
      font-family: Source-KeynoteartHans;
      font-style: italic;
      font-weight: 900;
      font-size: 2.8em;
      margin-bottom: 0.2em;
      overflow: hidden;
      /* 确保超出部分不显示 */
      border-right: 3px solid #333;
      /* 光标效果 */
      white-space: nowrap;
      /* 防止文本换行 */
      animation: typing 4s steps(12, end), blink-caret 0.5s step-end 10;

      // @media (max-width: 900px) {
      //   font-size: 32px;
      // }
    }

    .topleftSubTitle {
      color: #424242;
      font-weight: 600;
      font-size: 1.2em;
    }
  }

  .topImg {
    width: 65%;
    img {
      width: 100%;
    }
  }

  /* 打字动画 */
  @keyframes typing {
    from {
      width: 0;
    }

    to {
      width: 100%;
    }
  }

  /* 光标闪烁动画 */
  @keyframes blink-caret {

    from,
    to {
      border-color: transparent;
    }

    50% {
      border-color: #333;
    }
  }
}


// @media(max-width:768px) {
//   .topBanner {
//     height: auto;
//   }

//   .bannerBox {
//     flex-wrap: wrap;
//     width: 100vw;
//   }

//   .topLeft {
//     box-sizing: border-box;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     padding: 0 !important;
//     margin: 0 !important;
//     width: 100vw;

//     .bannerTitle {
//       text-align: center;
//     }

//     .topLeftTitle {
//       font-size: 7vw !important;
//       margin-bottom: 3vw !important;
//     }

//     .topleftSubTitle {
//       font-size: 4vw !important;
//     }
//   }

//   .commonBtn {
//     margin-top: 1rem;
//   }

//   .topImg {
//     width: 100vw;
//   }
// }
</style>
